var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"interserv-header mb-3"},[_vm._v(" alice Interview "),_c('span',{staticStyle:{"font-size":"14pt"},domProps:{"innerHTML":_vm._s(_vm.envName)}})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }